"use-strict"

import moment from "moment"

import AuthService from "../../../app/services/auth/auth.service"
import CacheService from "../../../app/services/cache/cache.service"
import ContractService from "../../../app/services/contract/contract.service"
import BreadcrumbService from "../../../app/services/breadcrumb-service/breadcrumb.service"
import OrganizationService from "../../../app/services/organization/organization.service"
import OrderService from "../../../app/services/order/order.service"
import StaticContentService from "../../../app/services/static/static-content.service"
import { OrderManager } from "../../../app/model/domain/order-manager"
import { OrganizationUsageStats } from "../../../app/model/domain/organization-usage-stats"
import IncentiveAssignmentLimitV1Controller from "../../../app/components/incentive-assignment-limit-v1-dialog/incentive-assignment-limit-v1-dialog.controller"
import AdminInvitesTeachersDialogController from "../../../app/components/admin-invites-teachers-dialog/admin-invites-teachers-dialog.controller"
import { Locations } from "../../../app/services/mixpanel/mixpanel.service"
import { statsTimePeriod } from "../statsTimePeriod"
import AnalyticsService from "../../../app/services/analytics/analytics.service"

/**
 * @param {AuthService} AuthService
 * @param {CacheService} CacheService
 * @param {ContractService} ContractService
 * @param {BreadcrumbService} BreadcrumbService
 * @param {OrganizationService} OrganizationService
 * @param {OrderService} OrderService
 * @param {StaticContentService} StaticContentService
 */
export class SchoolsMetricsPageController {
  /**
   * @param {AuthService} AuthService
   * @param {CacheService} CacheService
   * @param {AnalyticsService} AnalyticsService
   * @param {ContractService} ContractService
   * @param {BreadcrumbService} BreadcrumbService
   * @param {OrganizationService} OrganizationService
   * @param {OrderService} OrderService
   * @param {StaticContentService} StaticContentService
   */
  constructor(
    $q,
    $filter,
    $location,
    $state,
    $mdSidenav,
    $log,
    $mdDialog,
    AuthService,
    CacheService,
    AnalyticsService,
    ContractService,
    BreadcrumbService,
    OrganizationService,
    OrderService,
    StaticContentService,
  ) {
    "ngInject"

    this.$mdDialog = $mdDialog
    this.$mdSidenav = $mdSidenav

    /** @type {AuthService} */
    this._authService = AuthService
    /** @type {StaticContentService} */
    this._staticContentService = StaticContentService
    /** @type {CacheService} */
    this._cacheService = CacheService
    /** @type {OrganizationService} */
    this._organizationService = OrganizationService
    /** @type {OrderService} */
    this._orderService = OrderService
    /** @type {AnalyticsService} */
    this._analyticsService = AnalyticsService

    this.$q = $q
    this.$log = $log
    this.$filter = $filter
    this.$location = $location
    this.$state = $state
    /** @type {OrderManager} */
    this._orderManager = new OrderManager(
      $q,
      $log,
      $filter,
      $mdDialog,
      $location,
      AuthService,
      OrderService,
      OrganizationService,
      BreadcrumbService,
      CacheService,
      ContractService,
    )

    this._incentiveAssignmentLimitV1 = IncentiveAssignmentLimitV1Controller.show
    this._adminInvitesTeachersDialog = AdminInvitesTeachersDialogController.show

    this._user = this._authService.authData

    this._analyticsService.SchoolsMetricsPageOpened(this._user)
  }

  get errorMessage() {
    return "Sorry, there was a problem loading the metrics for this organization"
  }

  goToTeachersMetricsPage(organizationId) {
    this.$state.go("root.account.nav.metrics-teachers", { organizationId })
  }

  toggleSidenav() {
    this.$mdSidenav("nav").toggle()
  }

  /**
   * @returns {boolean}
   */
  isUserAdminOfAnyContract() {
    return this._user.isAdminOfAnyContract()
  }

  /**
   * @param {string} organizationId
   * @param {OrganizationUsageStats} usageStats
   * @param {Order} order
   * @returns {boolean}
   */
  shareMetrics(organizationId, usageStats, order) {
    this._orderManager.shareMetrics(
      order,
      undefined,
      undefined,
      Locations.METRICS,
      false,
      usageStats,
    )
  }

  /**
   * @param {Organization} organization
   */
  inviteUsers(organization) {
    this._incentiveAssignmentLimitV1(
      Locations.METRICS,
      this.$mdDialog,
      this._user,
      [organization],
    )
  }

  /**
   * @param {Organization} organization
   */
  nudgeTeachers(organization) {
    this._adminInvitesTeachersDialog(
      this.$mdDialog,
      organization && organization.id,
      Locations.METRICS,
    )
  }

  /**
   * @returns {string}
   */
  get statsTimePeriod() {
    return statsTimePeriod()
  }

  /**
   * @returns {Promise<OrganizationMetricsData[]>}
   */
  getOrganizationsMetricsData() {
    return this._organizationService.getOrganizationMetricsData()
  }

  /**
   * @param {string} organizationId
   * @returns {Promise<Order>}
   */
  getActiveOrder(organizationId) {
    return this._orderService.getActiveOrder(organizationId)
  }

  goToWatchTutorialVideo() {
    this._staticContentService.goToGettingStartedVideoTwo()
  }
}
